const eventName = 'save-event'

type SaveEventData = {
  type: 'save'
  formId?: string
}

export type SaveEvent = CustomEvent<SaveEventData>

function subscribeSaveEvent(event: SaveEvent) {
  // @ts-ignore
  document.addEventListener(eventName, event)
}

function unsubscribeSaveEvent(event: SaveEvent) {
  // @ts-ignore
  document.removeEventListener(eventName, event)
}

function publishSaveEvent(data: SaveEventData) {
  const event = new CustomEvent<SaveEventData>(eventName, { detail: data })
  document.dispatchEvent(event)
}

export { publishSaveEvent, subscribeSaveEvent, unsubscribeSaveEvent }
